export class Reco {
    dni: string;
    id_reco: string;
    apellidos: string;
    nombre: string;
    empresa: string;
    fecha: string;
}